import { useEffect, useState } from "react";
import axios from "axios";
import { Users, Phone, Building2, ScanFace } from "lucide-react";
import { API_BASE, BACKEND_URL } from "../../lib/site";

const maskCPFView = (cpf) => (cpf || "").replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");

export default function AdminClientes() {
    const [clientes, setClientes] = useState([]);

    useEffect(() => {
        axios.get(`${API_BASE}/clientes`, { withCredentials: true }).then(({ data }) => setClientes(data)).catch(() => {});
    }, []);

    return (
        <section id="admin-clientes" data-testid="admin-clientes-section" className="scroll-mt-28">
            <div className="flex items-center gap-3">
                <Users className="w-6 h-6 text-[#0E6B3F]" />
                <h2 className="text-2xl font-extrabold">Clientes cadastrados ({clientes.length})</h2>
            </div>
            <p className="mt-2 text-sm text-[#1A231E]/60 font-semibold">
                Moradores com acesso ao app — com CPF, foto facial e condomínio de cadastro.
            </p>

            <div className="mt-5 grid sm:grid-cols-2 gap-4" data-testid="clientes-list">
                {clientes.map((c) => (
                    <div key={c.id} data-testid="cliente-item" className="rounded-[1.5rem] bg-white border-2 border-[#1A231E]/12 sticker-soft p-5 flex gap-4">
                        {c.foto_path ? (
                            <img src={`${BACKEND_URL}/api/media/${c.foto_path}`} alt={c.nome} className="w-16 h-16 rounded-2xl object-cover border-2 border-[#0E6B3F] shrink-0" />
                        ) : (
                            <span className="w-16 h-16 rounded-2xl bg-[#0E6B3F]/10 grid place-items-center shrink-0">
                                <ScanFace className="w-7 h-7 text-[#0E6B3F]" />
                            </span>
                        )}
                        <div className="min-w-0">
                            <p className="font-extrabold truncate">
                                {c.nome}
                                <span className={`ml-2 text-[10px] font-extrabold uppercase px-2 py-0.5 rounded-full align-middle ${c.maior_de_18 ? "bg-[#0E6B3F]/10 text-[#0E6B3F]" : "bg-[#F57A3A]/15 text-[#F57A3A]"}`}>
                                    {c.maior_de_18 ? "Maior de 18" : "Menor de 18"}
                                </span>
                            </p>
                            <p className="text-xs font-bold text-[#1A231E]/50 mt-1">CPF {maskCPFView(c.cpf)}</p>
                            <p className="text-xs font-bold text-[#1A231E]/50 flex items-center gap-1 mt-0.5">
                                <Phone className="w-3 h-3" />
                                {c.telefone}
                            </p>
                            <p className="text-xs font-bold text-[#1A231E]/50 flex items-center gap-1 mt-0.5">
                                <Building2 className="w-3 h-3" />
                                {c.condominio}
                            </p>
                            {c.created_at && (
                                <p className="text-[10px] font-bold uppercase tracking-wider text-[#1A231E]/35 mt-1.5">
                                    Cadastro em {new Date(c.created_at).toLocaleDateString("pt-BR")}
                                </p>
                            )}
                        </div>
                    </div>
                ))}
                {clientes.length === 0 && (
                    <p className="sm:col-span-2 rounded-2xl border-2 border-dashed border-[#1A231E]/15 px-6 py-10 text-center text-sm font-semibold text-[#1A231E]/50">
                        Nenhum cliente cadastrado ainda. O link do app é /app.
                    </p>
                )}
            </div>
        </section>
    );
}
